import { Link } from 'react-router-dom';
import palette from '@mlc/mlc-palette';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScreenSize } from '../../../../enums';

export const RouterLink = styled(Link)`
	color: ${palette.mlcWhite};
	font-weight: 400;
	text-decoration: underline;

	:hover,
	:focus {
		text-decoration: none;
	}
`;

export const AnchorLink = styled.a`
	color: ${palette.mlcWhite};
	font-weight: 400;
	text-decoration: underline;

	:hover,
	:focus {
		text-decoration: none;
	}
`;

export const Ol = styled.ol`
	margin: 0;
	margin-left: 0;
	margin-top: 0;
	padding-left: 0;
	padding-top: 16px;
`;

export const Li = styled.li`
	display: inline;

	@media (max-width: ${ScreenSize.small}) {
		display: none;
	}
`;

export const Chevron = styled(FontAwesomeIcon)`
	color: ${palette.mlcWhite};
	margin: 0 15px;
`;

export const Nav = styled.nav`
	display: inline;
`;
